import axios from "axios";
import qs from "qs";
import { alert, clear, removeItem, push } from "utils/defaultData";
import { closeBrowser } from "api/wechatSDK";
import store from "store";
import { errorLog } from "api/user";

axios.defaults.timeout = 30000; //响应时间
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头
axios.defaults.headers.patch["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头
axios.defaults.baseURL = ""; //配置接口地址

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  (config) => {
    //在发送请求之前做某件事
    if (config.method === "post") {
      let type = axios.defaults.headers.post["Content-Type"];
      if (type == "application/json") {
        config.data = JSON.stringify(config.data);
      } else {
        config.data = qs.stringify(config.data, { arrayFormat: "repeat" });
      }
    } else if (config.method === "patch") {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  (error) => {
    //console.log('错误的传参')
    return Promise.reject(error);
  }
);

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  (res) => {
    // console.log(res);
    if (res.data.status != 200) {
      if ((res.data.status == 403) & (location.href.indexOf("/register") < 0)) {
        if (location.href.indexOf("coupons") < 0) {
          push({ path: "/coupons" });
        } else {
          push({ path: "/register" });
        }
      } else if (res.data.status == 401) {
        clear();
        store.commit("setPageLoading", false);
        alert("访问超时，请重新进入").then(() => {
          closeBrowser();
        });
        res.data.msg = "访问超时，请重新进入";
      } else if (res.data.status == 400) {
        return Promise.resolve(res);
      } else {
        clear();
        alert(res.data.message).then(() => {});
      }
    } else {
      return Promise.resolve(res);
    }
  },
  (error) => {
    console.log("Error");
    console.log(error);
    // console.log('网络异常')
    clear();
    store.commit("setPageLoading", false);
    console.log(error.config);
    let params =
      error.config.method == "post"
        ? error.config.data
        : JSON.stringify(error.config.params);
    if (params.length > 300) {
      params = params.substring(0, 300);
    }
    if (error.config.url.indexOf("errorlog") < 0) {
      //JSON.stringify(error.config)
      errorLog(
        "",
        error.message +
          " , url : " +
          error.config.url +
          " , method : " +
          error.config.method +
          " , params : " +
          params +
          " , " +
          navigator.userAgent
      ).then((res) => {
        if (res.status == "success") {
          if (error.message.indexOf("timeout") > 0) {
            alert("网络不稳定，请刷新页面或稍后再访问");
          } else if (error.message == "Network Error") {
            removeItem("appId");
            removeItem("count");
            alert("网络异常，请稍后再试").then(() => {
              closeBrowser();
            });
          } else {
            alert("网络异常，请稍后再试").then(() => {
              window.history.go(-1);
            });
          }
        }
      });
    }
    return Promise.reject(error);
  }
);
//post请求JSON参数
export function fetchPostJson(url, params) {
  axios.defaults.headers.post["Content-Type"] = "application/json";
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        (response) => {
          if (response != null && response != "" && response != undefined)
            resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
//patch请求
export function fetchPatch(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, params)
      .then(
        (response) => {
          if (response != null && response != "" && response != undefined)
            resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
//delete请求
export function fetchDelete(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then(
        (response) => {
          if (response != null && response != "" && response != undefined)
            resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        (response) => {
          if (response.data.status != 0) {
            resolve(response.data);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
/*
 * 返回一个Promise(发送get请求)
 */
export function fetchGet(url, param) {
  axios.defaults.headers.get["Content-Type"] = "application/json";
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: param,
      })
      .then(
        (response) => {
          if (response.data.status != 0) {
            resolve(response.data);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
export function fetchGetJson(url, param) {
  axios.defaults.headers.get["Content-Type"] = "application/json";
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: param,
      })
      .then(
        (response) => {
          if (response.data.status != 0) {
            resolve(response.data);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
export default {
  fetchPost,
  fetchGet,
  fetchPostJson,
  fetchPatch,
  fetchDelete,
  fetchGetJson,
};
